import { defineTokens } from '@chakra-ui/react';

export const gradients = defineTokens({
	gradients: {
		footer:  { value: 'linear-gradient(360deg, #FFFFFF 0%, #C4EAFF 100%)' },
		primary: { value: 'linear-gradient(180deg, #027FC3 0%, #D2EFFF 43.9%)' },
	},
});
